import Alert from 'primitives/Alert';

import constants from 'utils/constants';

export default function FundInformation({ fund }: { fund: any }) {
  return (
    <>
      <Alert
        type="warning"
        title="Confidential: Disclosing fund information will result in removal from Angellist India"
      />
      <div className="divide-y divide-gray-200 space-y-9">
        <div>
          <div className="flex items-start space-x-5 mt-8">
            <div className="flex-shrink-0">
              <div className="relative">
                <img
                  className="h-16 w-16 rounded-lg object-contain bg-white"
                  src={fund.image || constants.ALT_AVATAR_URL}
                  alt={fund.name}
                />
                <span className="absolute inset-0 rounded-lg shadow-inner" aria-hidden="true" />
              </div>
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">{fund.name}</h1>
              <div
                className="prose text-gray-500 break-words"
                dangerouslySetInnerHTML={{ __html: fund.description }}
              />
            </div>
          </div>
        </div>
        <div className="pb-32 pt-8">
          <div className="space-y-4">
            <p className="text-xs font-light text-gray-500">
              AngelList India and its affiliates do not provide investment advice to investors, and
              the information on this page should not be relied upon as research, investment advice
              or a recommendation of any kind.
            </p>
            <p className="text-xs font-light text-gray-500">
              Past performance is not indicative of future returns. Examples of past investments by
              syndicates are purely for illustrative purposes. There is no guarantee that any
              syndicate will achieve the same exposure to or quality of portfolio companies held by
              any existing AngelList India syndicate funds.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
